import ReviewingApplicationCard from "components/card/reviewing-application/ReviewingApplication";
import ApplicationContainer from "components/application-container/ApplicationContainer";
import { useMarkApplicationSubmitted } from "hooks";

const ReviewingApplicationPage = () => {
    useMarkApplicationSubmitted();

    return (
        <>
            <title>We're Reviewing Your Application | AAA Life</title>
            <ApplicationContainer useTitle={false} data-testid="reviewing-application-page">
                <ReviewingApplicationCard />
            </ApplicationContainer>
        </>
    );
};

export default ReviewingApplicationPage;
